import { render, staticRenderFns } from "./Add-b.vue?vue&type=template&id=0134a342&lang=pug"
import script from "./Add-b.vue?vue&type=script&lang=js"
export * from "./Add-b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports